/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {handleEvent} from '../../../../events/event-handler';
import {isEmpty} from '../../../../utilities/validation';
import TextNodeContainer from '../elements/text-node';
import ImageNode from '../elements/image-node';
import VideoNode from '../elements/video-node';
import TextAreaNode from '../elements/textarea-node';
import ButtonNode from '../elements/button-node';
import McNode from '../elements/mc-node';
import CeNode from '../elements/ce-node';
import AudioNodeContainer from '../elements/audio-node';
import DdNode from '../elements/dd-node';
import TimerNode from '../elements/timer-node';
import AnimatedImageNode from '../elements/animation_image_node';
import AssessmentNode from '../elements/assessment/assessment-node';
import TeNode from '../elements/te-node';
import ActionButtonNodeContainer from '../elements/action-button-node';
import SlideshowNode from '../elements/slideshow-node';
/* eslint-enable no-unused-vars */

const getStateFromProps = function(props = {}) {
    const { content = {} } = props;
    const {
        pageId = null,
        textNodesList = [],
        videoNodesList = [],
        imageNodesList = [],
        animatedImageNodesList = [],
        textAreaNodesList = [],
        buttonNodesList = [],
        mcNodesList = [],
        ceNodesList = [],
        audioNodesList = [],
        eventNodesList = [],
        ddNode = null,
        timerNode = null,
        assessmentNode = null,
        actionButtonNodesList = null,
        teNode = null,
        slideshowNode = null,
    } = content;

    return {
        pageId,
        textNodesList,
        videoNodesList,
        imageNodesList,
        animatedImageNodesList,
        textAreaNodesList,
        buttonNodesList,
        ceNodesList,
        audioNodesList,
        eventNodesList,
        ddNode,
        mcNodesList,
        timerNode,
        assessmentNode,
        teNode,
        actionButtonNodesList,
        slideshowNode,
    };
};

// we only check for the onPageLoad event currently. If there is a different event_node name, we will need to adjust this
const handlePageNodeEvents = (eventNodesList) => {
    // The onPageLoad event is a child of PageNode (MO.IDIN.3.0.1 Page 707)
    eventNodesList.forEach(function (event) {
        if (event.attr.name === 'onPageLoad') {
            setTimeout(function(){ // timeout is present so that nodes targeted by onPageLoad are mounted
                handleEvent(event);
            }.bind(this), 1000);
        }
    });
};

class BookContent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...getStateFromProps(props),
            selectedCeNodes: {},
            completedMcNodes: {},
        };

        this.setActiveCeNode = this.setActiveCeNode.bind(this);
        this.clearCeNodeContentView = this.clearCeNodeContentView.bind(this);
        this.setMcNodeToCompleted = this.setMcNodeToCompleted.bind(this);
    }

    // eslint-disable-next-line no-unused-vars
    componentDidUpdate(prevProps, prevState, snap) {
        let {completedMcNodes, mcNodesList} = this.state;

        if (prevProps.content.pageId !== this.props.content.pageId){ //on page change, reset completedMcNodes
            completedMcNodes = {};
            if(!isEmpty(mcNodesList) && mcNodesList !== prevState.mcNodesList) {
                // To avoid confusion, completedMcNodes is also used when only a single mc-node exists
                for (let i = 0; i < mcNodesList.length; i++) {
                    const mcNodeXMLElement = mcNodesList[i];
                    const {attr: {id, variable}} = mcNodeXMLElement;

                    if (!completedMcNodes.hasOwnProperty(id)) { // otherwise false is set each time component "Receives Props"
                        const completedMcNodeKey = isEmpty(variable) ? id : `${id}-${variable}`;
                        completedMcNodes[completedMcNodeKey] = false;
                    }
                }

                this.setState({
                    completedMcNodes,
                });
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const {content:{eventNodesList, pageId,}} = nextProps;

        if (!isEmpty(eventNodesList) && pageId !== this.props.content.pageId) {
            handlePageNodeEvents(eventNodesList);
        }

        this.setState({
            ...getStateFromProps(nextProps),
        });
    }

    setActiveCeNode(ceNodeId) {
        const selectedCeNodes = this.state.ceNodesList.reduce(
            (selected, n) => {
                return {...selected, [n.attr.id]: ceNodeId === n.attr.id};
            }, {}
        );
        this.setState({selectedCeNodes});
    }

    clearCeNodeContentView() {
        const selectedCeNodes = this.state.ceNodesList.reduce(
            (selected, n) => {
                return {...selected, [n.attr.id]: false};
            }, {}
        );
        this.setState({selectedCeNodes});
    }

    setMcNodeToCompleted(mcNodeId){
        /*
        * setMcNodeToCompleted does not have an explicit return,
        * mcNodeId is passed from mc-node.js when mcCompleted === true; when all values in completedMcNodes ===
        *  true, it is safe to enable overlay-mask in mc-node
        * JIRA reference ticket MOD-2410
        * */
        const {completedMcNodes} = this.state;

        if(completedMcNodes.hasOwnProperty(mcNodeId)){
            this.setState(prevState => ({
                completedMcNodes: {                     // object that we want to update
                    ...prevState.completedMcNodes,      // keep all other key-value pairs
                    [mcNodeId]: true                    // update the value of specific key
                }
            }));
        }
    }

    render() {
        const {moduleURL, moduleID, sessionNum, pageNum, style = {},
            enableJREAppPlayerContainerButtons, disableJREAppPlayerContainerButtons} = this.props;
        const {completedMcNodes} = this.state;

        return (
            <div className="book-content" style={style}>
                { this.state.textNodesList.map(node =>
                    <TextNodeContainer
                        key={node.attr.id}
                        node={node}
                    />)
                }
                { this.state.animatedImageNodesList.map(node =>
                    <AnimatedImageNode
                        moduleURL={moduleURL}
                        key={node.attr.id}
                        node={node}
                        multiAnimatedImageNodes={this.state.animatedImageNodesList.length > 1}
                    />)
                }
                { this.state.imageNodesList.map(node =>
                    <ImageNode
                        moduleURL={moduleURL}
                        key={node.attr.id}
                        node={node}
                    />)
                }
                { this.state.videoNodesList.map(node =>
                    <VideoNode
                        key={node.attr.src}
                        node={node}
                        moduleURL={moduleURL}
                        enableJREAppPlayerContainerButtons={enableJREAppPlayerContainerButtons}
                        disableJREAppPlayerContainerButtons={disableJREAppPlayerContainerButtons}
                    />)
                }
                { this.state.textAreaNodesList.map(node =>
                    <TextAreaNode
                        moduleURL={moduleURL}
                        key={node.attr.id}
                        node={node}
                    />) }
                { this.state.buttonNodesList.map(node =>
                    <ButtonNode
                        key={node.attr.id}
                        node={node}
                        moduleURL={moduleURL}
                    />)
                }
                { this.state.audioNodesList.map(node =>
                    <AudioNodeContainer
                        moduleURL={moduleURL}
                        key={node.attr.id}
                        node={node}
                        enableJREAppPlayerContainerButtons={enableJREAppPlayerContainerButtons}
                        disableJREAppPlayerContainerButtons={disableJREAppPlayerContainerButtons}
                    />)
                }
                { this.state.mcNodesList.map(node =>
                    <McNode
                        moduleURL={moduleURL}
                        moduleID={moduleID}
                        sessionNum={sessionNum}
                        pageNum={pageNum}
                        key={node.attr.id}
                        node={node}
                        enableJREAppPlayerContainerButtons={enableJREAppPlayerContainerButtons}
                        disableJREAppPlayerContainerButtons={disableJREAppPlayerContainerButtons}
                        setMcNodeToCompleted={this.setMcNodeToCompleted}
                        completedMcNodes={completedMcNodes}
                    />)
                }
                { this.state.ceNodesList.map(node =>
                    <CeNode
                        moduleURL={moduleURL}
                        key={node.attr.id}
                        selectedCeNodes={this.state.selectedCeNodes}
                        onActiveCeNode={this.setActiveCeNode.bind(this)}
                        clearCeNodeContentView={this.clearCeNodeContentView.bind(this)}
                        node={node}
                        enableJREAppPlayerContainerButtons={enableJREAppPlayerContainerButtons}
                        disableJREAppPlayerContainerButtons={disableJREAppPlayerContainerButtons}
                    />)
                }
                { this.state.ddNode &&
                <DdNode
                    key={this.state.ddNode.attr.id}
                    node={this.state.ddNode}
                    moduleURL={moduleURL}
                    enableJREAppPlayerContainerButtons={enableJREAppPlayerContainerButtons}
                    disableJREAppPlayerContainerButtons={disableJREAppPlayerContainerButtons}
                />
                }
                { (this.state.timerNode !== null) &&
                <TimerNode key={`${this.state.timerNode.attr.id}-${pageNum}`}
                           node={this.state.timerNode}
                           moduleURL={moduleURL}
                           enableJREAppPlayerContainerButtons={enableJREAppPlayerContainerButtons}
                           disableJREAppPlayerContainerButtons={disableJREAppPlayerContainerButtons}
                />
                }
                { (this.state.assessmentNode !== null) &&
                <AssessmentNode
                    moduleURL={moduleURL}
                    key={this.state.assessmentNode.attr.id}
                    nextPage={this.props.nextPage}
                    node={this.state.assessmentNode}
                    exitViewer={this.props.exitViewer}
                    enableJREAppPlayerContainerButtons={enableJREAppPlayerContainerButtons}
                    disableJREAppPlayerContainerButtons={disableJREAppPlayerContainerButtons}
                />
                }
                { this.state.actionButtonNodesList &&
                this.state.actionButtonNodesList.map(node =>
                    <ActionButtonNodeContainer
                        moduleURL={moduleURL}
                        key={node.attr.id}
                        node={node}
                    />)
                }
                { (this.state.teNode !== null) &&
                <TeNode
                    moduleURL={moduleURL}
                    key={`${this.state.teNode.attr.id}-${pageNum}`} // we need pageNum as part of the key, because the ID "TE" commonly repeats (not unique)
                    node={this.state.teNode}
                    moduleID={moduleID}
                    sessionNum={sessionNum}
                    pageNum={pageNum}
                    enableJREAppPlayerContainerButtons={enableJREAppPlayerContainerButtons}
                    disableJREAppPlayerContainerButtons={disableJREAppPlayerContainerButtons}
                />
                }
                { (this.state.slideshowNode !== null) &&
                <SlideshowNode
                    node={this.state.slideshowNode}
                    moduleURL={moduleURL}
                />
                }
            </div>
        );
    }

}

BookContent.propTypes = {
    content: PropTypes.shape({
        pageId: PropTypes.string,
        textNodesList: PropTypes.array,
        videoNodesList: PropTypes.array,
        imageNodesList: PropTypes.array,
        animatedImageNodesList: PropTypes.array,
        textAreaNodesList: PropTypes.array,
        buttonNodesList: PropTypes.array,
        ceNodesList: PropTypes.array,
        audioNodesList: PropTypes.array,
        ddNode: PropTypes.object,
        mcNodesList: PropTypes.array,
        timerNode: PropTypes.object,
        assessmentNode: PropTypes.object,
        actionButtonNodesList: PropTypes.array,
        slideshowNode: PropTypes.object,
    }).isRequired
};

export default BookContent;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/book/book-content.js